import React from 'react';
import { connect } from 'react-redux';
import {
  Modal,
  ModalHeader,
  ModalBody,
  ModalFooter,
  Button,
} from 'reactstrap';
import SentimentDetail from './SentimentDetail';
import SentimentBreakdown from './SentimentBreakdown';

class RecordCallerSentimentModal extends React.PureComponent {
  constructor(props) {
    super(props);

    const callerSentiment = props.record.caller_sentiment || {};
    this.state = { callerSentiment };
  }

  render() {
    const { callerSentiment } = this.state;
    const {
      toggle,
      focusedId,
      record,
    } = this.props;

    return (
      <Modal
        isOpen={focusedId === record.contact_id}
        toggle={toggle}
        className="mt-6"
        zIndex="100000"
      >
        <ModalHeader className="text-capitalize">
          {`Caller Sentiment: ${record.client_first_name} ${record.client_last_name}`}
        </ModalHeader>
        <ModalBody className="text-center">
          <h5>
            <span>Overall Sentiment: </span>
            <SentimentDetail score={callerSentiment.Sentiment} />
          </h5>
          <div className="py-0">
            <SentimentBreakdown scores={callerSentiment.SentimentScore} />
          </div>
        </ModalBody>
        <ModalFooter>
          <Button color="white" onClick={toggle}>Close</Button>
        </ModalFooter>
      </Modal>
    );
  }
}

const mapStateToProps = (store) => ({
  focusedId: store.records.callerSentimentModalId,
});

const mapDispatchToProps = {
  toggle: () => ({ type: 'TOGGLE_RECORD_CALLER_SENTIMENT' }),
};

export default connect(mapStateToProps, mapDispatchToProps)(RecordCallerSentimentModal);
